/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedSearches_itemSearch = {
    readonly relatedSearches: ReadonlyArray<{
        readonly anchorText: string | null;
        readonly url: string | null;
    } | null> | null;
    readonly " $refType": "SbSharedRelatedSearches_itemSearch";
};
export type SbSharedRelatedSearches_itemSearch$data = SbSharedRelatedSearches_itemSearch;
export type SbSharedRelatedSearches_itemSearch$key = {
    readonly " $data"?: SbSharedRelatedSearches_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedSearches_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedSearches_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RelatedSearch",
      "kind": "LinkedField",
      "name": "relatedSearches",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "anchorText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '36860d0a1909b8fd27abf5f83703848e';
export default node;
